import script from "./buySuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./buySuccess.vue?vue&type=script&setup=true&lang=js"

import "./buySuccess.vue?vue&type=style&index=0&id=16a956dc&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16a956dc"]])

export default __exports__